import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';
import { styles } from '../constants/styles.js';

var hidden = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__hidden",
  componentId: "sc-1bkv38q-0"
})(["", " ", " ", ""], function (props) {
  return props.$above ? css(["", "{display:none;}"], styles.breakpoint[props.$above]) : null;
}, function (props) {
  return props.$below ? css(["", "{display:none;}"], styles.breakpointMax[props.$below]) : null;
}, boxStyles);

export { hidden };
